import React, { useEffect, useState } from 'react';
import api from '../api';
import './AdvancedPurchase.css';

const copyText = async (text) => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch {
        // запасной способ ниже
    }
    const area = document.createElement('textarea');
    area.value = text;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch { ok = false; }
    document.body.removeChild(area);
    return ok;
};

/** «Пригласите коллег»: личная ссылка и код, сколько человек пришло и сколько дней заработано. */
function ReferralCard() {
    const [info, setInfo] = useState(null);
    const [copied, setCopied] = useState(null);

    useEffect(() => {
        api.get('/users/me/referral').then((res) => setInfo(res.data)).catch(() => setInfo(null));
    }, []);

    if (!info || !info.enabled) return null;

    const copy = async (what, text) => {
        setCopied((await copyText(text)) ? what : `${what}-fail`);
        setTimeout(() => setCopied(null), 2500);
    };

    return (
        <div className="profile-card referral">
            <h2 className="profile-section-title">Пригласите коллег</h2>
            <p className="purchase__muted">
                Коллега получит <b>+{info.friend_days} дней</b> «Расширенного» к первой оплате по вашей ссылке или коду,
                а вы — <b>+{info.referrer_days} дней</b>, когда он оплатит.
            </p>
            <div className="referral__row">
                <input className="form-input" readOnly value={info.link} onFocus={(e) => e.target.select()} aria-label="Реферальная ссылка" />
                <button type="button" className="btn btn--primary" onClick={() => copy('link', info.link)}>
                    {copied === 'link' ? 'Скопировано ✓' : 'Копировать ссылку'}
                </button>
            </div>
            <div className="referral__code">
                Или продиктуйте код: <b>{info.code}</b>
                <button type="button" className="purchase__link" onClick={() => copy('code', info.code)}>
                    {copied === 'code' ? 'скопирован ✓' : 'копировать'}
                </button>
            </div>
            {String(copied || '').endsWith('-fail') && (
                <div className="purchase__promo-msg purchase__promo-msg--error">Браузер не дал скопировать — выделите текст и нажмите Ctrl+C.</div>
            )}
            <div className="referral__stats">
                <span>Пришли по ссылке: <b>{info.registered}</b></span>
                <span>Оплатили: <b>{info.paid}</b></span>
                <span>Вам начислено: <b>{info.days_earned} дн.</b></span>
            </div>
        </div>
    );
}

export default ReferralCard;
